import React from 'react';
import { Box, Button, Container, Stack, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from 'react-i18next'; // 1. Import hook

// Ensure the path to your image is correct
import CtaBackgroundImage from '../assets/images/b5t-removebg-preview.png';

// --- Color Palette ---
const PALETTE = {
  stoneWhite: '#FCF9F3',
  peacockTeal: '#005B5C',
  saffronOrange: '#FCA510',
  textPrimary: '#1A2027',
  textSecondary: '#5F5F5F',
};

const FinalCTA = () => {
  const { t } = useTranslation(); // 2. Initialize translation function
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        py: { xs: 10, md: 16 },
        color: PALETTE.stoneWhite,
        textAlign: 'center',
        backgroundImage: `linear-gradient(rgba(26, 32, 39, 0.65), rgba(26, 32, 39, 0.65)), url(${CtaBackgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        width: '100vw',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            component="h2"
            variant="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              lineHeight: 1.2,
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            }}
          >
            {t('final_cta_headline')} {/* 3. Use translation */}
          </Typography>

          <Typography
            variant="h6"
            component="p"
            sx={{
              color: 'rgba(252, 249, 243, 0.9)',
              maxWidth: '700px',
              mx: 'auto',
              mb: 4,
            }}
          >
            {t('final_cta_paragraph')} {/* 3. Use translation */}
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            sx={{ width: isMobile ? '100%' : 'auto', alignItems: 'center' }}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                backgroundColor: '#FCA510',
                color: '#1A2027',
                fontWeight: 700,
                fontSize: '1rem',
                py: 2,
                px: 6,
                borderRadius: '50px',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                '&:hover': {
                  backgroundColor: '#e69500',
                  transform: 'translateY(-3px)',
                  boxShadow: '0 7px 20px rgba(0,0,0,0.25)',
                },
              }}
            >
              {t('final_cta_button')} {/* 3. Use translation */}
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default FinalCTA;